/**
 * Checks if the provided value is a Validation object.
 *
 * @param {RegExp | Validation<T> | T} value - The value to check.
 * @returns {boolean} - True if the value is a Validation object, false otherwise.
 */
export const isValidationObject = (value) => value.message !== undefined;
